import { useCallback } from 'react';
import { App } from 'antd';
import { skuAPI } from '../../../../services/api';

export const useSKUDelete = (onSuccess: () => void) => {
    const { message, modal } = App.useApp();

    const handleDelete = useCallback(async (id: number) => {
        modal.confirm({
            title: '确认删除',
            content: '删除后将无法恢复，确定要删除这个SKU吗？',
            onOk: async () => {
                try {
                    await skuAPI.delete(id);
                    message.success('删除成功');
                    onSuccess();
                } catch (error) {
                    message.error('删除失败');
                }
            },
        });
    }, [onSuccess, modal, message]);

    return { handleDelete };
};
